var exports = {
  "uu": "VoiceLobbyShared.module__actionButtons___ZExHN1",
  "hP": "VoiceLobbyShared.module__actionButton___ZExHN1",
  "zc": "VoiceLobbyShared.module__iconContainer___ZExHN1",
  "KA": "VoiceLobbyShared.module__iconContainerBrand___ZExHN1",
  "cF": "VoiceLobbyShared.module__iconContainerDanger___ZExHN1",
  "hO": "VoiceLobbyShared.module__iconContainerTertiary___ZExHN1",
  "cY": "VoiceLobbyShared.module__iconContainerSuccess___ZExHN1",
  "gE": "VoiceLobbyShared.module__actionIcon___ZExHN1",
  "uI": "VoiceLobbyShared.module__actionIconSecondary___ZExHN1",
  "K2": "VoiceLobbyShared.module__actionText___ZExHN1",
  "Hd": "VoiceLobbyShared.module__connectionInfo___ZExHN1",
  "Il": "VoiceLobbyShared.module__connectionHeader___ZExHN1",
  "p1": "VoiceLobbyShared.module__connectionStatusInfo___ZExHN1",
  "bn": "VoiceLobbyShared.module__connectionTitle___ZExHN1",
  "fV": "VoiceLobbyShared.module__connectionSubtitle___ZExHN1",
  "Cb": "VoiceLobbyShared.module__connectionStatusDot___ZExHN1",
  "wL": "VoiceLobbyShared.module__statsGrid___ZExHN1",
  "N8": "VoiceLobbyShared.module__statRow___ZExHN1",
  "Zh": "VoiceLobbyShared.module__statLabel___ZExHN1",
  "cR": "VoiceLobbyShared.module__statValue___ZExHN1",
  "_x": "VoiceLobbyShared.module__statValuePrimary___ZExHN1",
  "V4": "VoiceLobbyShared.module__endpointValue___ZExHN1",
  "TR": "VoiceLobbyShared.module__connectionIdValue___ZExHN1",
  "JX": "VoiceLobbyShared.module__maxWidth___ZExHN1",
};

module.exports = exports;
